import React from "react";
import { Controller } from "react-hook-form";
import { FBasicPropos } from "../../../interfaces/User.interface";
import { Box } from "@mui/material";

const discountTypeLabelMap: Record<string, string> = {
  percent: "Percent",
  fixed: "Fixed Amount",
};

export const FCoursePreviewField: React.FC<FBasicPropos> = ({
  field, control, errors, errorMessage
}) => {
  const { name } = field;
  if (!errorMessage) errorMessage = errors[name]?.message as string;

  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { value } }) => {
        const isValid = Array.isArray(value) && value.length > 0;

        return (
            <Box sx={{backgroundColor: "#f9f9f9", borderRadius: 2, width: "100%", fontSize: 13, display: "table", borderCollapse: "collapse"}}>
                <Box sx={{display: "table-row", fontWeight: 500, borderBottom: "1px solid #ccc",}}>
                    <Box sx={{ display: "table-cell", padding: 1 }}>Course</Box>
                    <Box sx={{ display: "table-cell", padding: 1 }}>Teacher</Box>
                    <Box sx={{ display: "table-cell", padding: 1 }}>Price</Box>
                    <Box sx={{ display: "table-cell", padding: 1 }}>Discount Type</Box>
                    <Box sx={{ display: "table-cell", padding: 1 }}>Discount Value</Box>
                </Box>

            {isValid &&
              value.map((course: any, idx: number) => {
                const {
                  courseName,
                  teacherName,
                  price,
                  discountType,
                  discountValue,
                } = course;

                return (
                    <Box key={idx} sx={{display: "table-row",borderBottom: "1px solid #eee",}}>
                        <Box sx={{ display: "table-cell", padding: 1 }}>{courseName}</Box>
                        <Box sx={{ display: "table-cell", padding: 1 }}>{teacherName}</Box>
                        <Box sx={{ display: "table-cell", padding: 1 }}>${Number(price).toFixed(2)}</Box>
                        <Box sx={{ display: "table-cell", padding: 1 }}>
                            {discountTypeLabelMap[discountType] ?? "No discount"}
                        </Box>
                        <Box sx={{ display: "table-cell", padding: 1 }}>
                            {discountValue ?? 0}
                        </Box>
                    </Box>
                );
              })}
          </Box>
        );
      }}
    />
  );
};

export default FCoursePreviewField;

